export const RegisterUser={
    CREATE_ONLINE_USER_VIEW:"CREATE_ONLINE_USER_VIEW",
    VALIDATE_GST:"VALIDATE_GST",
    GENERATE_OTP:"GENERATE_OTP",
    VALIDATE_OTP:"VALIDATE_OTP",
    CREATE_ONLINE_USER:"CREATE_ONLINE_USER",
    REGISTER_USER_SUCCESS:"REGISTER_USER_SUCCESS",
}